import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import LoginIndex from '../components/login/LoginIndex';
import { getUrlParam } from '../utils/request';
import { REST_PASSWORD } from '../utils/constants';

export default connect(state => state)(
  injectIntl(
    class extends React.Component {
      constructor(props) {
        super(props);
      }

      componentDidMount() {
        const domain = getUrlParam('domainName') || ''; //将uri中的域名放到sessionStorage中
        //设置URL带来的域名
        domain &&
          this.props.dispatch({ type: 'login/getDomain', domainName: domain });
        sessionStorage.setItem('uri_domain', domain);
        const type = getUrlParam('type');
        if (type === REST_PASSWORD) {
          //找回密码，邮箱的连接，直接打开输入密码
          const userId = getUrlParam('userId');
          const user = { userId: userId, domainName: domain, resetType: 1 };
          this.props.dispatch({ type: 'login/setRestUser', restUser: user });
          this.props.dispatch({
            type: 'login/setDivType',
            divType: REST_PASSWORD
          });
        } else if (type === 'ACTIVE_DOMAIN') {
          //注册域激活
          const email = getUrlParam('email');
          this.props.dispatch({
            type: 'login/activeDomain',
            payload: { email, domainName: domain }
          });
        }
        const lang = getUrlParam('lang');
        if (lang) {
          this.props.dispatch({ type: 'i18n/setLocale', locale: lang });
        }
      }

      render() {       
        const {
          intl,
          dispatch,
          login: loginData,
          location,
          menu: menuData,
          i18n
        } = this.props;
        const { system, loginId } = location.query;
        if (system || loginId) {
          return null;
        } else {
          return (
            <div ref={ref => this.tt = ref}>
              <LoginIndex
                intl={intl}
                dispatch={dispatch}
                loginData={loginData}
                menuData={menuData}
                locale={i18n.locale}
              />
            </div>
          );
        }
      }
    }
  )
);



// WEBPACK FOOTER //
// ./src/routes/IndexPage.js